















import { computed, defineComponent } from "@vue/composition-api";
import { format } from "date-fns";
import { ContentPurchase } from "@scrile/api-provider/dist/api/ContentPriceProvider";
import { resolveUserName } from "@/lib/userHelpers";
import BaseAvatar from "@/components/BaseAvatar";

export default defineComponent({
  name: "UnlockedListItem",
  components: { BaseAvatar },
  props: {
    data: { type: Object as () => ContentPurchase, required: true },
  },
  setup(props) {
    const date = computed(() => {
      return format(new Date(props.data.time), "MM/dd/yy");
    });
    const time = computed(() => {
      return format(new Date(props.data.time), "hh:mm a");
    });

    return { date, time, resolveUserName };
  },
});
